import React, {Component} from 'react';
import {RTLTable, RTLCol, RTLButton} from '../RTLKit';
import {Divider, Row, Pagination, Typography, Form} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';
import moment from "jalali-moment";
import DatePickerField from "../formFields/DatePickerField";
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'کد درخواست',
        dataIndex: 'order_system_code',
        sorter: (a, b) => a.order_system_code - b.order_system_code,
        width:"10%"
    },
    {
        title: 'نام محصول',
        dataIndex: 'product',
        width:"10%",
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
        width:"5%",
        className:'price'
    },
    {
        title: 'انبار',
        dataIndex: 'ware_house',
        width:"15%",
    },
    {
        title: 'توضیحات',
        dataIndex: 'description',
    },
    {
        title: 'تاریخ',
        dataIndex: 'date',
        width:'10%'
    },
  ];


class WarehouseList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            pageTitle: null,
            filter:[]
        }

        this.__onChangeCounter = this.__onChangeCounter.bind(this)

    }

    componentDidMount() {
        let param = []
        let id = this.props.match.params.id

        let url = (this.props.match.path).split("/");
        switch (url[2]) {
            case 'product':
                param = {product :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,product :id}
                }))
            break;
            case 'state':
                param = {state :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,state :id}
                }))
            break;
            case 'order':
                param = {order :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,order :id}
                }))
            break;
            case 'technician':
                param = {technician :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,technician :id}
                }))
            break;

        }

        this.props.getList(param);
        this.props.getProductList({size:365})
        // this.props.getProductList({size:1000})
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        clearInterval(this.interval);
        this.setState({current: pageNumber});

        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        // let id = this.props.match.params.id
        // let url = (this.props.match.path).split("/");
        // switch (url[2]) {
        //     case 'product':
        //         await this.setState(prevState  => ({
        //             filter: {...prevState.filter,product :id}
        //         }))
        //         break;
        //     case 'state':
        //         await this.setState(prevState  => ({
        //             filter: {...prevState.filter,state :id}
        //         }))
        //         break;
        //     case 'order':
        //         await this.setState(prevState  => ({
        //             filter: {...prevState.filter,order :id}
        //         }))
        //         break;
        //     case 'technician':
        //         await this.setState(prevState  => ({
        //             filter: {...prevState.filter,technician :id}
        //         }))
        //         break;
        // }
        this.props.getList(this.state.filter);


    }

    __getProductList() {
        let list = this.props.productList;
        let dataSource = [];

        if (list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {

                dataSource.push(
                    {label: list.lists[i].title, value: list.lists[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        const { Text } = Typography;
        var list = this.props.list;
        var dataSource = [];
        let count;
        let wareHouse;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                if(parseInt(list.lists[i].count) < 0)
                    count = "danger"
                else
                    count = "success"
                if(list.lists[i].row_type === 'CENTRAL_WAREHOUSE')
                    wareHouse = "مرکزی"
                else if(list.lists[i].row_type === 'STATE_WAREHOUSE')
                    wareHouse = "استان "+list.lists[i].state.title
                else if(list.lists[i].row_type === 'TECHNICIAN_WAREHOUSE')
                    wareHouse =  list.lists[i].technician && list.lists[i].technician.name ? list.lists[i].technician.name+' '+list.lists[i].technician.family+' ('+list.lists[i].technician.system_code+')' : null
                else if(list.lists[i].row_type === 'ORDER_WAREHOUSE')
                    wareHouse = 'سفارش ('+list.lists[i].order.system_code+')'+' تاریخ انجام '+moment(list.lists[i].order.finished_time).format('jYYYY/jM/jD')

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code : list.lists[i].system_code,
                    order_system_code : list.lists[i] && list.lists[i].order ? list.lists[i].order.system_code : '',
                    product : list.lists[i].product.title,
                    count : <Text type={count}>{list.lists[i].count}</Text>,
                    ware_house : wareHouse,
                    description: list.lists[i].description,
                    date: moment(list.lists[i].created_at).format('jYYYY/jM/jD'),
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.product)
            this.setState(prevState  => ({
                filter: {...prevState.filter,product:this.state.product}
            }))
        if(this.state.created_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_from:this.state.created_from}
            }))
        if(this.state.created_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_to:this.state.created_to}
            }))
        if(this.state.warehouse_type)
            this.setState(prevState  => ({
                filter: {...prevState.filter,warehouse_type:this.state.warehouse_type}
            }))
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        let param = []
        let id = this.props.match.params.id

        let url = (this.props.match.path).split("/");
        switch (url[2]) {
            case 'product':
                param = {product :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,product :id}
                }))
                break;
            case 'state':
                param = {state :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,state :id}
                }))
                break;
            case 'order':
                param = {order :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,order :id}
                }))
                break;
            case 'technician':
                param = {technician :id}
                this.setState(prevState  => ({
                    filter: {...prevState.filter,technician :id}
                }))
                break;

        }
        this.props.getList(param);
        this.props.getProductList()
        this.setState({current:1})
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={21}>
                        <Divider orientation="left">گزارش انبار {this.state.pageTitle}</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={3} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_from:created_from}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_to:created_to}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="product"
                                    component={SelectField}
                                    placeholder="محصول"
                                    list={this.__getProductList()}
                                    onChange={(product) => this.setState({product:product})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="warehouse_type"
                                    component={SelectField}
                                    placeholder="نوع انبار"
                                    list={[
                                        {label: 'مرکزی', value: 'central', key: 1},
                                        {label: 'استان', value: 'state', key: 2},
                                        {label: 'تکنسین', value: 'technician', key: 3}
                                    ]}
                                    onChange={(warehouse_type) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,warehouse_type:warehouse_type}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : this.state.size)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default WarehouseList = reduxForm({
    form: 'list'
})(WarehouseList)
